import isEmpty from 'lodash/isEmpty'

export default campaignLandingTemplate

/** @ngInject */
function campaignLandingTemplate($compile, $state, CampaignLanding, CampaignLandingType) {
    return ({
        restrict: 'E',
        scope: {
            stateParams: '=',
            campaign: '=',
        },
        link(scope, element) {
            const isNotPreviewMode = isEmpty(scope.stateParams.tokenId)
            if (isNotPreviewMode) {
                const referrer = isEmpty(document.referrer) ? undefined : document.referrer
                scope.email = ''
                scope.submit = function () {
                    CampaignLanding.submitCampaignInformation({
                        id_campaign: scope.campaign.id,
                        type: CampaignLandingType.SUBSCRIBE,
                        referrer,
                        mail: scope.email,
                    })
                    return $state.go(scope.campaign.redirect_state)
                }

                localStorage.id_campaign = scope.campaign.id
                CampaignLanding.submitCampaignInformation({
                    id_campaign: scope.campaign.id,
                    type: CampaignLandingType.VISITE,
                    referrer,
                })
            }

            element.html(scope.campaign.html)
            return $compile(element.contents())(scope)
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/campaignLanding/campaignLandingTemplate.js